import { InertiaApp } from '@inertiajs/inertia-vue';
import PortalVue from 'portal-vue';
import Vue from 'vue';
import VueMeta from 'vue-meta';
import VueTimeago from 'vue-timeago';
import TextHighlight from 'vue-text-highlight';
import Fragment from 'vue-fragment';
import UniqueId from 'vue-unique-id';
import Vuelidate from 'vuelidate';
import onlyInt from 'vue-input-only-number';
import VueMobileDetection from 'vue-mobile-detection';
import VueDatepickerUi from 'vue-datepicker-ui';
import 'vue-datepicker-ui/lib/vuedatepickerui.css';

window._ = require('lodash');
window.dateFns = require('date-fns');

Vue.config.productionTip = false;
Vue.mixin({ methods: { route: window.route } });
Vue.use(InertiaApp);
Vue.use(PortalVue);
Vue.use(VueMeta);
Vue.use(VueTimeago, {
    name: 'Timeago',
    locale: 'en',
    converter: (date, locale, converterOptions) => {
        const { includeSeconds, addSuffix = true } = converterOptions;
        const parsedDate = dateFns.parseISO(date);

        return dateFns.formatDistanceToNow(parsedDate, {
            locale,
            includeSeconds,
            addSuffix
        });
    }
});
Vue.use(Fragment.Plugin);
Vue.use(UniqueId);
Vue.use(Vuelidate);
Vue.use(onlyInt);
Vue.use(VueMobileDetection);

Vue.component('text-highlight', TextHighlight);
Vue.component('vue-datepicker', VueDatepickerUi);

Vue.filter('lowercase', function (value) {
    return value.toLowerCase();
});

Vue.filter('date', {
    read: function (val) {
        return formatDate(parseDate(val));
    },
    write: function (val, oldVal) {
        const d = parseDate(val);
        return d ? formatDate(d) : val;
    }
});

const app = document.getElementById('app');

window.Bus = new Vue();

new Vue({
    metaInfo: {
        titleTemplate: title => title || 'Reckless'
    },
    render: h =>
        h(InertiaApp, {
            props: {
                initialPage: JSON.parse(app.dataset.page),
                resolveComponent: name =>
                    import(`@/Pages/${name}`).then(module => module.default)
            }
        })
}).$mount(app);

// ---
